import isString from "lodash/isString";
import { getUserInfoApi } from "@/services/user";
import useUserStore from "@/stores/useUserStore";
import useAppStore from "@/stores/useAppStore";
import ArmsRum from "@arms/rum-browser";
import zhugeInstance from "@/utils/zhugeSdk";

export const getUserInfo = async (token: string) => {
  const { initAppStore } = useAppStore.getState();
  if (!isString(token)) {
    return false;
  }

  initAppStore(token);

  const res = await getUserInfoApi();
  zhugeInstance.identify(res?.model?.accountId, {
    name: res?.model?.name,
    companyName: res?.model?.companyName,
    id:res?.model?.accountId
  })
  if (!res.success) {
    return false;
  }

  const { setUserInfo } = useUserStore.getState();
  setUserInfo(res.model);
  try {
    const config = ArmsRum.getConfig();
    ArmsRum.setConfig({
      ...config,
      user: {
        name: `${res.model.name}@${res.model.companyName}`,
        tag: res.model.accountId,
      },
    });
  } catch (e) {
    console.log(e);
  }
  return true;
};
